import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    fontFamily: 'Roboto',
    '@media all and (max-width: 900px)': {
      height: '100vh',
      marginTop: 80
    }
  },
  boxtitle: {
    width: '90%',
    display: 'flex',
    color: '#4B4952',
    marginLeft: '5%',
    marginTop: '1.5rem'
  },
  title: {
    fontSize: '2em',
    letterSpacing: '0.04rem',
    '@media all and (max-width: 600px)': {
      fontSize: '1.5em'
    }
  },
  boxSubTitle: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    color: '#4B4952',
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    paddingBottom: 10,
    paddingTop: 10,
    marginLeft: '5%',
    marginTop: '0.5rem',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    }
  },
  subtitle: {
    fontSize: '0.9rem',
    marginLeft: 8,
    fontWeight: 'bold'
  },
  boxTable: {
    width: '95%',
    marginTop: '1rem',
    marginLeft: '5%'
  },
  boxButtonAdd: {
    marginTop: '1.2rem',
    marginLeft: '5.5%',
    display: 'flex'
  },
  boxDetails: {
    width: '80%',
    marginLeft: '5%',
    marginTop: '2%',
    paddingBottom: 5,
    paddingTop: 5,
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10
  },
  confirmButton: {
    width: 120,
    height: 35,
    marginLeft: '5%',
    backgroundColor: '#00A88F',
    cursor: 'pointer',

    borderRadius: '23px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#1BF57F'
    }
  }
}))

export default useStyles
